import { render, staticRenderFns } from "./PwaInstallTop.vue?vue&type=template&id=5e4dfc72&scoped=true&"
import script from "./PwaInstallTop.vue?vue&type=script&lang=js&"
export * from "./PwaInstallTop.vue?vue&type=script&lang=js&"
import style0 from "./PwaInstallTop.vue?vue&type=style&index=0&id=5e4dfc72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4dfc72",
  null
  
)

export default component.exports